import { type DefaultContext, mutationPromise } from '@egw/clients'
import { createQueryHook } from '../../../../hooks'
import { type EnrollmentMultiWireTransferData, type EnrollmentMultiWireTransferAccountData } from '../../../../models'

/**
 * Get Enrollment Multi WireTransfer Account data
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<EnrollmentMultiWireTransferData>
 * @example const response = await getEnrollmentMultiWireTransferAccountData()
 */
export const getEnrollmentMultiWireTransferAccountData = async (
  context?: DefaultContext,
): Promise<EnrollmentMultiWireTransferAccountData> => {
  const response = (await mutationPromise(
    {
      name: 'getEnrollmentMultiWireTransferData',
      query: `query getEnrollmentMultiWireTransferData {
        wealthOverview {
          highYieldChecking {
            accounts {
              routingNumber
              accountNumber
            }
          }
        }
      }`,
    },
    {},
    context,
  )) as { wealthOverview: EnrollmentMultiWireTransferAccountData }
  return response.wealthOverview
}

export const useGetEnrollmentMultiWireTransferAccountData = createQueryHook<
  undefined,
  EnrollmentMultiWireTransferAccountData
>(getEnrollmentMultiWireTransferAccountData)

/**
 * Get Enrollment Multi WireTransfer data
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<EnrollmentMultiWireTransferData>
 * @example const response = await getEnrollmentMultiWireTransferData()
 */
export const getEnrollmentMultiWireTransferData = async (
  context?: DefaultContext,
): Promise<EnrollmentMultiWireTransferData> => {
  const response = (await mutationPromise(
    {
      name: 'getEnrollmentMultiWireTransferData',
      query: `mutation getEnrollmentMultiWireTransferData($submitEnrollmentInput: SubmitEnrollmentInput!) {
        submitEnrollment(submitEnrollmentInput: $submitEnrollmentInput) {
          ... on SubmitEnrollmentSuccess {
            __typename
            path
            enrollmentData {
              applicationId
              firstName
              lastName
              addressLine1
              addressLine2
              addressCity
              addressPostalCode
              addressCountry
              addressRegionCode
            }
          }
          ... on SubmitEnrollmentError {
            __typename
            path
          }
        }
      }`,
    },
    {
      submitEnrollmentInput: {},
    },
    context,
  )) as { submitEnrollment: EnrollmentMultiWireTransferData }
  return response.submitEnrollment
}

export const useGetEnrollmentMultiWireTransferData = createQueryHook<undefined, EnrollmentMultiWireTransferData>(
  getEnrollmentMultiWireTransferData,
)
